module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/portable-related-1.jpeg";